import React from "react";
import { observer } from "mobx-react-lite";
import classnames from "classnames";
import styles from "./FilterButton.module.scss";
import { SvgV2 } from "../v2/BaseElements/SvgV2";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";
export const FilterButton: React.FC<{ isOpen: boolean; iconName?: TuvisIconNamesType; disabled?: boolean }> = observer(
  ({ isOpen, iconName, disabled }) => {
    return (
      <div
        className={classnames(styles.headerButton, {
          [styles.selected]: isOpen,
          [styles.disabled]: disabled,
        })}
      >
        <SvgV2 width={12} height={12} iconName={iconName || `filters-icon`} />
      </div>
    );
  }
);
